import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";

import API from "./config/API";

function CreateBedForm() {
  const navigate = useNavigate();
  const location = useLocation();

  const user = JSON.parse(localStorage.getItem("user"));
  const emailId = user?.emailId || "";

  const {
    roomName,
    roomId,
    floorId,
    floorName,
    createdBeds = 0,
    maxBedsCount = 0,
  } = location.state || {};

  const [bedName, setBedName] = useState("");

  const [popup, setPopup] = useState({
    msg: "",
    type: "",
  });

  const [form, setForm] = useState({
    actualPrice: "",
    offerPrice: "",
    offerEndDate: "",
    isSameCostApplyForRemainingBeds: false,

    // ✅ NEW FIELD
    bedCostPerDay: "",
  });

  // ---------------- POPUP ----------------
  const showPopup = (msg, type) => {
    setPopup({ msg, type });

    setTimeout(() => {
      setPopup({ msg: "", type: "" });
    }, 2500);
  };

  // ---------------- SAFETY CHECK ----------------
  useEffect(() => {
    if (!roomName || !roomId) {
      showPopup("Invalid navigation. Redirecting...", "error");

      setTimeout(() => {
        navigate("/floorRoomBedSelector");
      }, 1200);
    }
  }, []);

  // ---------------- FETCH BED NAME ----------------
  const fetchNextBedName = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));

      const response = await fetch(
        `${API.V1}/floor_rooms/getBedNamesByRoomName?roomName=${encodeURIComponent(
          roomName,
        )}&emailId=${encodeURIComponent(emailId)}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.jwtToken}`,
          },
        },
      );

      if (response.status === 401) {
        alert("Session Expired. Please login again.");
        localStorage.clear();
        navigate("/");
        return;
      }

      const data = await response.json();

      if (data.statusCode === 200) {
        setBedName(data.data);
      } else {
        showPopup(data.message || "Failed to fetch bed name", "error");
      }
    } catch (error) {
      console.error(error);
      showPopup("Failed to fetch bed name", "error");
    }
  };

  useEffect(() => {
    if (roomName && emailId) {
      fetchNextBedName();
    }
  }, [roomName, emailId]);

  // ---------------- INPUT ----------------
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  // ---------------- SUBMIT ----------------
  const handleSubmit = async () => {
    if (!form.actualPrice) {
      return showPopup("Please Enter Actual Price", "error");
    }

    if (!form.bedCostPerDay) {
      return showPopup("Please Enter Bed Cost Per Day", "error");
    }

    const payload = {
      bedName,
      roomId,
      floorId,
      floorName,
      roomName,
      bedCreatedBy: emailId,

      actualPrice: Number(form.actualPrice),
      offerPrice: form.offerPrice ? Number(form.offerPrice) : null,
      offerEndDate: form.offerEndDate || null,

      isSameCostApplyForRemainingBeds: form.isSameCostApplyForRemainingBeds,

      // ✅ NEW FIELD ADDED
      bedCostPerDay: form.bedCostPerDay ? Number(form.bedCostPerDay) : null,
    };

    try {
      const user = JSON.parse(localStorage.getItem("user"));

      const response = await fetch(`${API.V1}/floor_rooms/createBed`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user?.jwtToken}`,
        },
        body: JSON.stringify(payload),
      });

      if (response.status === 401) {
        alert("Session Expired. Please login again.");
        localStorage.clear();
        navigate("/");
        return;
      }

      const data = await response.json();

      const status = data?.statusCode;
      const message = data?.message;

      if (status === 200) {
        showPopup(message || "Bed Created Successfully", "success");

        setTimeout(() => {
          navigate("/floorRoomBedSelector");
        }, 1200);

        return;
      }

      if (status === 400) {
        showPopup(message || "Request failed", "error");

        setTimeout(() => {
          navigate("/floorRoomBedSelector");
        }, 1200);

        return;
      }

      showPopup("Something went wrong", "error");

      setTimeout(() => {
        navigate("/floorRoomBedSelector");
      }, 1200);
    } catch (err) {
      console.error(err);

      showPopup("Server Error", "error");

      setTimeout(() => {
        navigate("/floorRoomBedSelector");
      }, 1200);
    }
  };
  return (
    <div style={styles.container}>
      {/* POPUP */}
      {popup.msg && (
        <div
          style={{
            ...styles.popup,
            background: popup.type === "success" ? "#16a34a" : "#dc2626",
          }}
        >
          {popup.msg}
        </div>
      )}

      {/* CARD */}
      <div style={styles.card}>
        <h2 style={styles.title}>🛏 Create Bed</h2>

        <div style={styles.infoBox}>
          <span style={styles.label}>Floor Name</span>
          <span style={styles.value}>{floorName}</span>
        </div>

        <div style={styles.infoBox}>
          <span style={styles.label}>Room Name</span>
          <span style={styles.value}>{roomName}</span>
        </div>

        <div style={styles.infoBox}>
          <span style={styles.label}>Bed Name</span>
          <span style={styles.value}>{bedName || "Loading..."}</span>
        </div>

        <div style={styles.infoBox}>
          <span style={styles.label}>Beds Capacity</span>
          <span style={styles.value}>
            {createdBeds} / {maxBedsCount}
          </span>
        </div>

        {/* ACTUAL PRICE */}
        <div style={styles.inputGroup}>
          <label style={styles.inputLabel}>Actual Price/Month</label>
          <input
            type="number"
            name="actualPrice"
            value={form.actualPrice}
            onChange={handleChange}
            style={styles.input}
          />
        </div>

        {/* OFFER PRICE */}
        <div style={styles.inputGroup}>
          <label style={styles.inputLabel}>Offer Price</label>
          <input
            type="number"
            name="offerPrice"
            value={form.offerPrice}
            onChange={handleChange}
            style={styles.input}
          />
        </div>

        {/* BED COST PER DAY (NEW) */}
        <div style={styles.inputGroup}>
          <label style={styles.inputLabel}>Bed Price/Day</label>
          <input
            type="number"
            name="bedCostPerDay"
            value={form.bedCostPerDay}
            onChange={handleChange}
            style={styles.input}
            placeholder="Enter per day cost"
          />
        </div>

        {/* OFFER END DATE */}
        <div style={styles.inputGroup}>
          <label style={styles.inputLabel}>Offer End Date</label>
          <input
            type="date"
            name="offerEndDate"
            value={form.offerEndDate}
            onChange={handleChange}
            style={styles.input}
          />
        </div>

        {/* CHECKBOX */}
        <div style={styles.checkboxContainer}>
          <input
            type="checkbox"
            name="isSameCostApplyForRemainingBeds"
            checked={form.isSameCostApplyForRemainingBeds}
            onChange={handleChange}
            style={styles.checkbox}
          />
          <label style={styles.checkboxLabel}>
            Apply Same Cost For Remaining Beds
          </label>
        </div>

        <button style={styles.createBtn} onClick={handleSubmit}>
          ➕ Create Bed
        </button>
      </div>
    </div>
  );
}

export default CreateBedForm;

/* ================= STYLES ================= */

const styles = {
  container: {
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
    background: "linear-gradient(135deg, #dbeafe 0%, #f8fafc 100%)",
    fontFamily: "Arial, sans-serif",
  },

  card: {
    width: "650px",
    background: "#ffffff",
    padding: "35px",
    borderRadius: "20px",
    boxShadow: "0 15px 40px rgba(0,0,0,0.15)",
  },

  title: {
    textAlign: "center",
    marginBottom: "28px",
    fontSize: "30px",
    fontWeight: "bold",
    color: "#0f172a",
  },

  infoBox: {
    background: "#eff6ff",
    borderLeft: "6px solid #2563eb",
    padding: "14px 16px",
    borderRadius: "10px",
    marginBottom: "14px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  label: {
    fontWeight: "bold",
    color: "#1e3a8a",
    fontSize: "15px",
  },

  value: {
    color: "#0f172a",
    fontWeight: "600",
    fontSize: "15px",
  },

  inputGroup: {
    marginTop: "18px",
  },

  inputLabel: {
    display: "block",
    marginBottom: "8px",
    fontWeight: "bold",
    color: "#334155",
  },

  input: {
    width: "100%",
    padding: "14px",
    borderRadius: "10px",
    border: "1px solid #cbd5e1",
    outline: "none",
    fontSize: "15px",
    background: "#ffffff",
  },

  checkboxContainer: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginTop: "24px",
    background: "#f1f5f9",
    padding: "14px",
    borderRadius: "10px",
  },

  checkbox: {
    width: "20px",
    height: "20px",
    cursor: "pointer",
  },

  checkboxLabel: {
    fontWeight: "bold",
    color: "#0f172a",
    fontSize: "15px",
  },

  createBtn: {
    width: "100%",
    padding: "15px",
    marginTop: "28px",
    background: "linear-gradient(to right, #16a34a, #15803d)",
    color: "#ffffff",
    border: "none",
    borderRadius: "10px",
    fontWeight: "bold",
    fontSize: "17px",
    cursor: "pointer",
  },

  backBtn: {
    width: "100%",
    padding: "14px",
    marginTop: "14px",
    background: "#64748b",
    color: "#ffffff",
    border: "none",
    borderRadius: "10px",
    fontWeight: "bold",
    fontSize: "15px",
    cursor: "pointer",
  },

  popup: {
    position: "fixed",
    top: "20px",
    right: "20px",
    color: "#ffffff",
    padding: "12px 18px",
    borderRadius: "8px",
    fontWeight: "bold",
    zIndex: 9999,
    boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
  },
};
